import React from "react";
import { string } from "prop-types";
import { Text, TEXT_TYPES, TEXT_WEIGHTS, TEXT_ALIGNS } from "#library/components/Text/Text";
import { useModal } from "#library/components/Modal/ModalManagement/ModalContext";

// eslint-disable-next-line import/no-relative-parent-imports
import styles from "../modal.module.css";
export var ModalTitle = function ModalTitle(_ref) {
  var children = _ref.children;
  var _useModal = useModal(),
    withIllustration = _useModal.withIllustration;
  var textAlign = withIllustration ? TEXT_ALIGNS.CENTER : TEXT_ALIGNS.LEFT;
  return /*#__PURE__*/React.createElement(Text, {
    id: "dialogTitle",
    tag: "h1",
    type: TEXT_TYPES.HEADING_SMALL,
    align: textAlign,
    weight: TEXT_WEIGHTS.BLACK,
    resetSpacing: true,
    className: styles["jds-Modal__title"]
  }, children);
};
ModalTitle.propTypes = {
  children: string.isRequired
};